import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import AccountingConnection from '../../entities/accountingConnection';

/*
 * Delete/nullify anywhere this accountingConnection is used in other entities
 *
 * @param {AccountingConnection} accountingConnection
 */
export function deleteAccountingConnection(accountingConnection: AccountingConnection, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = accountingConnection.id;
    }

    /* Remove the actual accountingConnection */
    accountingConnection.status = 'D';
    accountingConnection.addedOn = newHRTimestamp();
    accountingConnection.addedBy = getCurrentUserId();
    accountingConnection.importSource = targetImportSource;
    accountingConnection.importId = mergeId;
    store.dispatch(Actions.AccountingConnectionActions.removeAccountingConnectionQueue(accountingConnection));
    
}